import { Layout } from 'game/LayoutManager';
import { CircleButton } from './circleButton';
import { Displays } from 'constants/layout';

export default class CloseSettings extends CircleButton {
    public areSettingsVisible = false;
    constructor(onClick: () => void) {
        super('btn-close', false);
        this.container.zIndex = 9000;
        this.container.alpha = 0.6;

        this.container.on('pointerdown', onClick);
        this.container.eventMode = 'static';
    }

    resize(): void {
        super.resize();
        switch (Layout.getDisplay()) {
            case Displays.MOBILE:
                this.container.position.set(153, 31);

                break;

            case Displays.TABLET:
                this.container.position.set(162, 39);
                break;
            case Displays.DESKTOP:
                this.container.position.set(162, 40);
                break;
        }
    }
}
